import React from "react";
import { UserRoundPen } from "lucide-react";
import { useFloatingWindows } from "@/lib/floatingWindows";

/** Opens the resident's Campus Residents home page — the one place resident data is edited. */
export function OpenResidentButton({ residentId, name, className = "", testid, onOpened }) {
  const { openWindow } = useFloatingWindows();
  if (!residentId) return null;
  const open = (e) => {
    e.stopPropagation();
    e.preventDefault();
    openWindow("campus_residents", { title: name ? `Campus Residents · ${name}` : "Campus Residents", focus: { residentId } });
    onOpened?.();
  };
  return (
    <span role="button" tabIndex={0} onClick={open} onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && open(e)} title="Open this resident in Campus Residents to edit" aria-label="Open resident"
      data-testid={testid || `open-resident-${residentId}`}
      className={`inline-flex items-center gap-1 shrink-0 px-2 py-0.5 border border-nex-gold/40 text-nex-gold rounded-sm font-mono text-[9px] tracking-[0.14em] uppercase cursor-pointer hover:bg-nex-gold/10 transition-colors ${className}`}>
      <UserRoundPen className="h-3 w-3" /><span className="hidden sm:inline">Open resident</span>
    </span>
  );
}
